import { render, staticRenderFns } from "./SearchLandingPage.vue?vue&type=template&id=589c36e4&scoped=true&"
import script from "./SearchLandingPage.vue?vue&type=script&lang=js&"
export * from "./SearchLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchLandingPage.vue?vue&type=style&index=0&id=589c36e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c36e4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeBenefits: require('/opt/render/project/src/channels2022/src/components/home-page/HomeBenefits.vue').default})
